import React, { useEffect } from 'react';
import HeroSection from '../components/tmf/HeroSection';
import ReadTimeRibbon from '../components/tmf/ReadTimeRibbon';
import ProblemSection from '../components/tmf/ProblemSection';
import JourneySection from '../components/tmf/JourneySection';
import FindingsSection from '../components/tmf/FindingsSection';
import MethodsSection from '../components/tmf/MethodsSection';
import SolutionSection from '../components/tmf/SolutionSection';
import AnalysisSection from '../components/tmf/AnalysisSection';
import ComprehensiveFindingsSection from '../components/tmf/ComprehensiveFindingsSection';
import ResearchFindingsSection from '../components/tmf/ResearchFindingsSection';
import ImpactSection from '../components/tmf/ImpactSection';
import ReflectionsSection from '../components/tmf/ReflectionsSection';
import './TMFProject.css';

const TMFProject: React.FC = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="tmf-project-page">
      <HeroSection />
      <ReadTimeRibbon />
      <ProblemSection />
      <JourneySection />
      <FindingsSection />
      <MethodsSection />
      <SolutionSection />
      <AnalysisSection />
      <ComprehensiveFindingsSection />
      {/* <ResearchFindingsSection /> */}

      {/* Project Continuation Ribbon */}
      <section className="tmf-continuation-ribbon">
        <div className="tmf-container">
          <div className="tmf-ribbon-content">
            <div className="tmf-ribbon-badge">Part One: Research Phase Complete</div>
            <h2 className="tmf-ribbon-title">Project Status</h2>
            <p className="tmf-ribbon-text">
              This is Part One of a year-long apprenticeship with the Toyota Mobility Foundation.
              Over 6 months, we conducted trauma-informed research to identify barriers food pantry users face.
            </p>
            <p className="tmf-ribbon-text">
              <strong>What's Next:</strong> We're now transitioning to Part Two: ideation and co-design.
              Working with Toyota and community partners, we'll develop mobility solutions based on these research insights.
            </p>
            <p className="tmf-ribbon-footer">
              <strong>Note:</strong> This case study will be updated as the project progresses.
            </p>
            <div className="tmf-ribbon-timeline">
              <div className="tmf-timeline-item completed">
                <div className="tmf-timeline-marker"></div>
                <div className="tmf-timeline-content">
                  <div className="tmf-timeline-label">Months 1-6</div>
                  <div className="tmf-timeline-title">Research & Analysis</div>
                </div>
              </div>
              <div className="tmf-timeline-connector">
                <svg className="tmf-connector-arrow" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="tmf-timeline-item active">
                <div className="tmf-timeline-marker"></div>
                <div className="tmf-timeline-content">
                  <div className="tmf-timeline-label">Months 7-12</div>
                  <div className="tmf-timeline-title">Ideation & Co-Design</div>
                  <div className="tmf-timeline-current-badge">Current Phase</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Temporarily hidden sections */}
      {/* <ImpactSection /> */}
      {/* <ReflectionsSection /> */}
    </div>
  );
};

export default TMFProject;
